import React, { useState, useEffect } from 'react';
import { navigate, Link } from 'gatsby';

import { Layout, Menu, Breadcrumb, Button } from 'antd';
import { IoMdLogOut } from 'react-icons/io';
import { MdOutlineVpnKey, MdShowChart } from 'react-icons/md';
import { BsListNested } from 'react-icons/bs';
import { GrCube, GrUpgrade } from 'react-icons/gr';
import { VscMailRead } from 'react-icons/vsc';
import { RiFlowChart, RiUserSettingsLine } from 'react-icons/ri';
import { GrUserSettings } from 'react-icons/gr';
import { Firebase } from '../../config/firebase';

import '../../styles/dahboard-layout.scss';
const { Header, Content, Footer, Sider } = Layout;

const FormContainer = ({ children, menuKey, pageTitle }) => {
    const logoutUser = () => {
        Firebase.auth()
            .signOut()
            .then(() => {
                // Sign-out successful.
                console.log('out');
                navigate('/');
            })
            .catch((error) => {
                // An error happened.
            });
    };
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider
                collapsible
                trigger={
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <IoMdLogOut size={20} />{' '}
                        <span style={{ fontSize: 13 }}>Logout</span>
                    </div>
                }
                onCollapse={() => logoutUser()}
            >
                <div className="logo">
                    <Link to="/">
                        <img
                            src="/form.svg"
                            height="30px"
                            style={{ paddingLeft: 20 }}
                        />
                    </Link>
                </div>
                <br />
                <br />
                <Menu
                    selectedKeys={[menuKey]}
                    defaultSelectedKeys={['1']}
                    mode="inline"
                >
                    <Menu.Item key="1" icon={<BsListNested />}>
                        <Link to="/forms">Forms</Link>
                    </Menu.Item>
                    <Menu.Item key="2" icon={<MdShowChart />}>
                        <Link to="/usage">Usage</Link>
                    </Menu.Item>
                    {/* <Menu.Item key="3" icon={<MdOutlineVpnKey />}>
                        <Link to="/accounts">Accounts</Link>
                    </Menu.Item> */}
                    <Menu.Item key="4" icon={<GrUpgrade />}>
                        <Link to="/plans">Plans</Link>
                    </Menu.Item>
                    <Menu.Item key="5" icon={<RiUserSettingsLine />}>
                        <Link to="/settings">Settings</Link>
                    </Menu.Item>
                    <Menu.Item key="6" icon={<VscMailRead />}>
                        <Link to="/contact">Contact</Link>
                    </Menu.Item>
                </Menu>
            </Sider>
            <Layout className="site-layout">
                <Header
                    className="site-layout-background"
                    style={{ padding: 0 }}
                >
                    <div className="header-menu">
                        <Link to="/plans" className="menu-item">
                            <GrUpgrade />
                            <span>Upgrade</span>
                        </Link>
                        <div className="menu-item">
                            <Link to="/settings">
                                <GrUserSettings />
                                <span>Account</span>
                            </Link>
                        </div>
                        <div className="menu-item">
                            <Link to="/forms/google-sheet">
                                <Button icon={<RiFlowChart />} type="primary">
                                    Create form
                                </Button>
                            </Link>
                        </div>
                    </div>
                </Header>
                <Content>
                    <div
                        className="site-layout-background main-layout"
                        style={{
                            padding: 24,
                            minHeight: 360,
                        }}
                    >
                        {children}
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default FormContainer;
